import { useEffect, useRef, useState } from 'react';

export const useTypewriterText = ({ text = '', time = 100, delay = 0, on }) => {
  const [writtenText, setWrittenText] = useState(text);
  const textStep = useRef(0);

  useEffect(() => {
    if (on) {
      const timeout = setTimeout(() => {
        setWrittenText('');
        textStep.current = 0;
        const interval = setInterval(() => {
          textStep.current++;
          setWrittenText(text?.slice(0, textStep.current));
          if (textStep.current === text.length) {
            clearInterval(interval);
          }
        }, time);
        return () => clearInterval(interval);
      }, delay);
      return () => clearTimeout(timeout);
    }
  }, [delay, text, time, on]);

  return { writtenText };
};
